import { render, staticRenderFns } from "./ContainerSR.vue?vue&type=template&id=4b52ca22&scoped=true"
import script from "./ContainerSR.vue?vue&type=script&lang=js"
export * from "./ContainerSR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b52ca22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b52ca22')) {
      api.createRecord('4b52ca22', component.options)
    } else {
      api.reload('4b52ca22', component.options)
    }
    module.hot.accept("./ContainerSR.vue?vue&type=template&id=4b52ca22&scoped=true", function () {
      api.rerender('4b52ca22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/ContainerSR.vue"
export default component.exports